import { Box, Drawer, DrawerContent, DrawerOverlay, Flex, useDisclosure, useBreakpointValue, Breadcrumb, BreadcrumbItem, BreadcrumbLink, HStack, Button } from '@chakra-ui/react'
import * as React from 'react'
import { Logo } from './Logo'
import { Sidebar } from './Sidebar'
import { ToggleButton } from './ToggleButton'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { IAppShellConfig } from './AppShell'
import { AppShellButton } from './AppShellButton'

export const Navbar = (props: { config?: IAppShellConfig | undefined; }) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true }, { ssr: false });  
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { config } = props;

  return (
    <Box 
      width="full" 
      py="4" 
      px={{ base: '4', md: '4' }} 
      //pt={isDesktop ? "18px" : "16px"} // 2px bottom border on desktop
      bg={isDesktop ? undefined : "bg-accent"} 
      h={isDesktop ? "80px" : "64px"}  
      borderStyle={isDesktop ? "solid" : undefined} 
      borderBottom={isDesktop ? "2px" : undefined}
      borderColor={isDesktop ? "rgb(226, 232, 240)" : undefined}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
        {!isDesktop && (
          <>
            <ToggleButton isOpen={isOpen} aria-label="Open Menu" onClick={onToggle} zIndex="unset !important" />
            <Drawer
              isOpen={isOpen}
              placement="left"
              onClose={onClose}
              //isFullHeight -> disabled to fix "mobile browser problem" -> added h="full" to container
              preserveScrollBarGap
              // Only disabled for showcase
              //trapFocus={false}
            >
              <DrawerOverlay />
              <DrawerContent h="full">
                <Sidebar onClose={onClose} isOpen={isOpen} />
              </DrawerContent>
            </Drawer>
          </>
        )}
        {config && config.breadcrumbs && (
          <Breadcrumb 
            spacing={isDesktop ? '8px' : '4px'}
            separator={isDesktop ? <ChevronRightIcon color='gray.600' /> : <ChevronRightIcon color='white' />}
            flexGrow={isDesktop ? undefined : "1"}
          >
            {config.breadcrumbs.map(b => (
              <BreadcrumbItem key={`bci-${b.text}`}>
                <BreadcrumbLink 
                  as={Button} 
                  variant="ghost" 
                  onClick={b.onClick}
                  color={isDesktop ? "gray.600" : "white"}
                  _hover={{ background: "unset", textDecoration: "unset", color: isDesktop ? "gray.900" : "gray.300" }}
                  fontSize={isDesktop ? "16px" : "14px"}
                >
                    {b.text}
                </BreadcrumbLink>
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
        )}
        {config && (
          <HStack spacing="3">
            <>
              {config.leftButton   && typeof(config.leftButton)   !== 'function' && <AppShellButton {...config.leftButton} />}
              {config.leftButton   && typeof(config.leftButton)   === 'function' && config.leftButton()}

              {config.centerButton && typeof(config.centerButton) !== 'function' && <AppShellButton {...config.centerButton} />}
              {config.centerButton && typeof(config.centerButton) === 'function' && config.centerButton()}

              {config.rightButton  && typeof(config.rightButton)  !== 'function' && <AppShellButton {...config.rightButton} />}
              {config.rightButton  && typeof(config.rightButton)  === 'function' && config.rightButton()}
            </>
          </HStack>
        )}
    </Box>
  );

  return (
    <Box width="full" py="4" px={{ base: '4', md: '8' }} bg="bg-accent">
      <Flex justify="space-between">
        <Logo />
        <ToggleButton isOpen={isOpen} aria-label="Open Menu" onClick={onToggle} zIndex="unset !important" />
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          //isFullHeight -> disabled to fix "mobile browser problem" -> added h="full" to container
          preserveScrollBarGap
          // Only disabled for showcase
          //trapFocus={false}
        >
          <DrawerOverlay />
          <DrawerContent h="full">
            <Sidebar onClose={onClose} isOpen={isOpen} />
          </DrawerContent>
        </Drawer>
      </Flex>
    </Box>
  )
}
